import React, { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";
import { Loading } from "@/components/site/ui";
import { Panel, AdminHeading, Th, Td } from "@/components/admin/ui";

export default function AdminAudit() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/audit").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <div>
      <AdminHeading title="Audit Log" subtitle="Immutable record of important actions. Cannot be edited through the app." />
      <Panel>
        {items === null ? <Loading /> : items.length === 0 ? <p className="text-sm text-muted-foreground py-4 text-center">No audit entries.</p> : (
          <div className="overflow-x-auto"><table className="w-full min-w-[700px]">
            <thead><tr><Th>When</Th><Th>User</Th><Th>Action</Th><Th>Record</Th><Th>Reason</Th></tr></thead>
            <tbody>{items.map((a) => (
              <tr key={a.id}>
                <Td className="whitespace-nowrap text-muted-foreground">{fmtDate(a.created_at)}</Td>
                <Td>{a.user_email || "—"}</Td>
                <Td className="text-pool">{a.action}</Td>
                <Td className="text-xs text-muted-foreground">{a.record_type} {a.record_id ? a.record_id.slice(0, 8) : ""}</Td>
                <Td className="text-xs">{a.reason || "—"}</Td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </Panel>
    </div>
  );
}
